export default {
  PUSH_TRAINING_PHASE_REPORT: 'PUSH_TRAINING_PHASE_REPORT',
  PUSH_TRAINING_PHASE_REPORTS: 'PUSH_TRAINING_PHASE_REPORTS',
  REMOVE_TRAINING_PHASE_REPORT: 'REMOVE_TRAINING_PHASE_REPORT',
  REPLACE_TRAINING_PHASE_REPORT: 'REPLACE_TRAINING_PHASE_REPORT',
  REPLACE_TRAINING_PHASE_REPORTS: 'REPLACE_TRAINING_PHASE_REPORTS',
  RESET_TP_PHASES_STATE: 'RESET_TP_PHASES_STATE',
  SET_TRAINING_PHASES_IS_ADDING_OBSERVATION_REPORT: 'SET_TRAINING_PHASES_IS_ADDING_OBSERVATION_REPORT',
  SET_TRAINING_PHASES_IS_ADDING_SCHEDULED_REPORT: 'SET_TRAINING_PHASES_IS_ADDING_SCHEDULED_REPORT',
  SET_TRAINING_PHASES_IS_EDITING_REPORT: 'SET_TRAINING_PHASES_IS_EDITING_REPORT',
  SET_TRAINING_PHASES_IS_EDITING_REPORT_MODAL_OPENED: 'SET_TRAINING_PHASES_IS_EDITING_REPORT_MODAL_OPENED',
  SET_TRAINING_PHASES_IS_LOADING: 'SET_TRAINING_PHASES_IS_LOADING',
  SET_TRAINING_PHASES_IS_SCHEDULING_REPORTS: 'SET_TRAINING_PHASES_IS_SCHEDULING_REPORTS',
  SET_TRAINING_PHASES_IS_VIEWING_REPORT: 'SET_TRAINING_PHASES_IS_VIEWING_REPORT',
  SET_TRAINING_PHASES_IS_VIEWING_REPORT_MODAL_OPENED: 'SET_TRAINING_PHASES_IS_VIEWING_REPORT_MODAL_OPENED',
  SET_TRAINING_PHASES_REPORTS: 'SET_TRAINING_PHASES_REPORTS',
  SET_SELECTED_TRAINING_PHASE: 'SET_SELECTED_TRAINING_PHASE',
  SET_SELECTED_TRAINING_PHASE_MODAL: 'SET_SELECTED_TRAINING_PHASE_MODAL',
};
